import '../assets/styling/layers.css';

import { useLocalStorage } from '@vueuse/core';
import { createVuetify } from 'vuetify';

// import KitwareMark from '@/src/components/icons/KitwareLogoIcon.vue';
import {
  DarkTheme,
  DefaultTheme,
  LightTheme,
  ThemeStorageKey,
} from '@/src/constants';

import 'vuetify/styles';

const vuetify = createVuetify({
  icons: {
    values: {
      // kitwareMark: {
      //   component: KitwareMark,
      // },
    },
  },
  theme: {
    defaultTheme: DefaultTheme,
    themes: {
      [DarkTheme]: {
        dark: true,
        colors: {
          'selection-bg-color': '#01579b',
          'selection-border-color': '#01579b',
        },
      },
      [LightTheme]: {
        dark: false,
        colors: {
          'selection-bg-color': '#b3e5fc',
          'selection-border-color': '#b3e5fc',
          'surface': '#f0f0f0',
          'on-surface-variant': '#d0d0d0',
        },
      },
    },
  },
  display: {
    mobileBreakpoint: 'lg',
    thresholds: {
      lg: 1024,
    },
  },
});

const theme = useLocalStorage(ThemeStorageKey, DefaultTheme);
if (theme.value !== DarkTheme && theme.value !== LightTheme) {
  theme.value = DefaultTheme;
}
vuetify.theme.change(theme.value);

export default vuetify;
